export default {
  allTrials: [
    'Interface with list of all trials and an overview of each trial on the platform. The interface allows you to visualize and edit information about each trial.'
  ],
  getTrials: [
    'Interface with list of all trials and an overview of each trial on the platform. The interface allows you to visualize and edit information about each trial.'
  ],
  addTrials: [
    'The interface allows you to search for a trial based on NCT number and add it to the platform. If the trial is not registered on clinicaltrials.gov, you can add the trial manually from the interface.'
  ],
  excludeTrials: [
    'Interface with list of all trials on the platform. The interface allows you to select and remove the trial from the platform.'
  ],
  conditions: [
    'Interface with list of all trial on the platform with the conditions mapped to them. The interface allows you to exclude conditions for a trial.'
  ],
  triageStudies: [
    'Interface with data regarding patients who have provided their contact information with the intent of being contacted for a clinical trial. The interface allows you to visualize and edit the filters the patient selected, their contact information and study of interest.'
  ],
  triagePatients: [
    'Interface with data regarding patients who have provided their contact information with the intent of being contacted for a clinical trial. The interface allows you to visualize and edit the filters the patient selected, their contact information and study of interest.'
  ],
  triageSource: [
    'Interface with data regarding patients who have provided their contact information with the intent of being contacted for a clinical trial. The interface allows you to visualize and edit the filters the patient selected, their contact information and study of interest.'
  ],
  studyContacts: [
    'Interface with contacts listed for each trial who receive an email notification when a patient provides their contact information to be contacted for a trial. The interface allows you to visualize and edit individual study contacts for each trial.'
  ],
  specialtyContacts: [
    'Interface with contacts listed for each trial who receive an email notification when a patient provides their contact information to be contacted for a trial. The interface allows you to visualize and edit individual study contacts for each trial.'
  ],
  xpertTriage: [
    'Interface with data regarding patients who have provided their contact information with the intent of being contacted for a clinical trial. The interface allows you to visualize and edit the filters the patient selected, their contact information and study of interest.'
  ],
  myPatients: [
    'Interface with data regarding patients who have provided their contact information with the intent of being contacted for a clinical trial. The interface allows you to visualize and edit the filters the patient selected, their contact information and study of interest.'
  ],
  searchPatients: [
    'Interface with details of all patients who have provided their contact information to be contacted for a trial and also patients who provided their contact information to be a part of newsletter. The interface allows you to a) send an email broadcast based on disease of interest to all patients who have expressed an interest in the condition, and b) send an email broadcast based on trial of interest to patients who have expressed an interest in the trial.'
  ],
  emailRecords: [
    'Interface with details of all patients who have provided their contact information to be contacted for a trial and also patients who provided their contact information to be a part of newsletter. The interface allows you to a) send an email broadcast based on disease of interest to all patients who have expressed an interest in the condition, and b) send an email broadcast based on trial of interest to patients who have expressed an interest in the trial.'
  ],
  priorityTrials: [
    'Interface with list of all trials on the platform. The interface allows you to select priority trials. Priority Trials will always be shown at the top of the search results.'
  ],
  surveyQuestions: [
    'Interface with a list of all the survey questions asked at the time of submission for a trial. These questions appear after the patient submits their information on the trial overview page. The interface allows you to add, remove, and edit the questions asked to the user.'
  ],
  studyLocation: [
    'Interface with location listed for each trial. The interface allows you to visualize study location for each trial.'
  ],
  bulkUploads: [
    'Interface with the ability to upload trials, contacts, and locations from a csv file.'
  ],
  userActivity: [
    "See Epic user's activity"
  ],
  userManagement: [
    'Interface for managing users'
  ]
}
